<template>
  <div class="nav-header">
    <div class="nav-content">
      <div class="logo">
        <div class="logo-text">Jixer的小屋</div>
      </div>
      
      <el-menu
        mode="horizontal"
        :default-active="activeMenu"
        class="nav-menu"
        :ellipsis="false"
        @select="handleMenuSelect"
        style="height: 55px"
      >
        <el-menu-item index="/" style="height: 55px">首页</el-menu-item>
        <!-- <el-menu-item index="/offer-process" style="height: 55px">工具箱</el-menu-item> -->
        <el-menu-item index="/tools" style="height: 55px">工具箱</el-menu-item>
      </el-menu>
      
      <!-- <div class="user-section desktop-only">
        <el-button v-if="!token" type="primary" size="medium" @click="goLogin">登录</el-button>
        <el-dropdown v-else @command="handleCommand">
          <span class="user-info">
            <el-avatar :size="24" :src="userInfo.avatar || defaultAvatar">
              {{ userInfo.nickname ? userInfo.nickname.charAt(0) : '用户' }}
            </el-avatar>
            <span class="username">{{ userInfo.nickname || '用户' }}</span>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="profile">个人中心</el-dropdown-item>
              <el-dropdown-item command="settings">设置</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div> -->
      
      <div class="mobile-menu-btn mobile-only" @click="drawerVisible = true">
        <el-icon :size="24"><Menu /></el-icon>
      </div>
    </div>
    
    <el-drawer
      v-model="drawerVisible"
      direction="rtl"
      size="70%"
      title="菜单"
    >
      <div class="mobile-menu">
        <el-menu
          :default-active="activeMenu"
          @select="handleMenuSelect"
        >
          <el-menu-item index="/" @click="drawerVisible = false">
            <el-icon><HomeFilled /></el-icon>
            <span>首页</span>
          </el-menu-item>
          <el-menu-item index="/article" @click="drawerVisible = false">
            <el-icon><Document /></el-icon>
            <span>文章</span>
          </el-menu-item>
          <el-menu-item index="/offer" @click="drawerVisible = false">
            <el-icon><Document /></el-icon>
            <span>面试流程</span>
          </el-menu-item>
        </el-menu>
        
        <div class="mobile-user-section">
          <el-button v-if="!token" type="primary" size="large" block @click="goLogin">登录</el-button>
          <div v-else class="user-info-mobile">
            <el-avatar :size="48" :src="userInfo.avatar || defaultAvatar">
              {{ userInfo.nickname ? userInfo.nickname.charAt(0) : '用户' }}
            </el-avatar>
            <span class="username">{{ userInfo.nickname || '用户' }}</span>
            <el-button type="danger" size="small" @click="handleLogout">退出</el-button>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { Menu, HomeFilled, Document } from '@element-plus/icons-vue'

export default {
  name: 'NavHeader',
  components: { Menu, HomeFilled, Document },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    
    const drawerVisible = ref(false)

    const token = computed(() => store.getters.token)
    const userInfo = computed(() => store.getters.userInfo)

    const activeMenu = computed(() => route.path)

    const defaultAvatar = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'

    const handleMenuSelect = (index) => {
      router.push(index)
    }

    const handleCommand = (command) => {
      if (command === 'logout') {
        store.dispatch('setToken', '')
        store.dispatch('setUserInfo', {})
        router.push('/')
      } else if (command === 'profile') {
        router.push('/profile')
      } else if (command === 'settings') {
        router.push('/settings')
      }
    }
    
    const handleLogout = () => {
      store.dispatch('setToken', '')
      store.dispatch('setUserInfo', {})
      drawerVisible.value = false
      router.push('/')
    }

    const goLogin = () => {
      drawerVisible.value = false
      router.push('/login')
    }

    return {
      token,
      userInfo,
      activeMenu,
      defaultAvatar,
      drawerVisible,
      handleMenuSelect,
      handleCommand,
      handleLogout,
      goLogin
    }
  }
}
</script>

<style scoped>
.nav-header {
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.logo {
  margin-right: 40px;
  display: flex;
  align-items: center;
}

.logo-text {
  font-size: 20px;
  font-weight: bold;
  color: #409eff;
  cursor: pointer;
}

.nav-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 55px;
  padding: 0 20px;
}

.nav-menu {
  flex: 1;
  border-bottom: none;
  --el-menu-item-height: 44px;
}

:deep(.el-menu-item) {
  height: 44px;
  line-height: 44px;
}

.user-section {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.username {
  margin-left: 8px;
  font-size: 14px;
}

.mobile-menu-btn {
  display: none;
  cursor: pointer;
  padding: 8px;
}

.mobile-menu {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.mobile-user-section {
  margin-top: 20px;
  padding: 20px;
  border-top: 1px solid #eee;
}

.user-info-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.desktop-only {
  display: flex;
}

.mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }
  
  .mobile-only {
    display: flex;
  }
  
  .nav-menu {
    display: none;
  }
  
  .logo {
    margin-right: 0;
  }
}
</style>
